import { Component, OnInit } from '@angular/core';
import { UserAccessModel } from '../shared/models/user-access.model';
import { AuthService } from '../shared/services/auth.service';
import { environment } from '../../environments/environment';
import { ApiService } from '../shared/services/api.service';
import { NgIf } from '@angular/common';
import { MaterialModule } from '../shared/material.module';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  imports: [NgIf, MaterialModule, RouterLink],
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  user: UserAccessModel | null;
  shipmentPortalUrl = environment.externalUrls.shipmentPortalUrl;

  constructor(
    private authService: AuthService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.authService.userInfo.subscribe((userInfo) => (this.user = userInfo));
  }

  getSuiteLinkUrl(): string {
    const failedUrl = window.location.origin;
    return `${environment.externalUrls.mgBase}?UserId=${this.user?.mercuryUsername}&Password=${this.user?.mercuryPassword}&failedurl=${failedUrl}`;
  }

  hasAccessTo(key: string): boolean {
    return !!this.user?.permissions?.find((item) => item.viewKey === key);
  }

  setUserGroup(): void {
    const migratedGroup =
      this.user?.migrationStatus === 3 ? 'migrated' : 'not-migrated';
    this.apiService
      .post<string>(
        environment.assignGroup +
          '?group=' +
          migratedGroup +
          '&email=' +
          this.user?.email
      )
      .subscribe({
        next: () => {
          window.open(environment.externalUrls.sisenseBase, '_blank');
        },
      });
  }

  redirectToLynncoBi(): void {
    window.open(environment.externalUrls.lynncoBiBase, '_blank');
  }
}
